// extracted by mini-css-extract-plugin
export default {"permissionsHeading":"CreateUserRoleModal_permissionsHeading__1vNS2"};